// Shared by the Reports list, the week page and the Reports sidebar.
import type { ReportListItem } from "../../api/types";

/** Badge tone per report state (DTP pastel pairs). */
export const REPORT_STATE_VARIANT = {
  draft: "neutral",
  generated: "info",
  sent: "success",
  failed: "danger",
} as const;

/** The newest version of each week, newest week first. */
export function latestByWeek(rows: ReportListItem[]): ReportListItem[] {
  const byWeek = new Map<string, ReportListItem>();
  for (const r of rows) {
    const seen = byWeek.get(r.week_key);
    if (!seen || r.version > seen.version) byWeek.set(r.week_key, r);
  }
  return [...byWeek.values()].sort((a, b) => b.week_key.localeCompare(a.week_key));
}
